"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLabels = void 0;
var types = __importStar(require("../labelTypes"));
exports.defaultLabels = (_a = {},
    _a[types.CREDIT_NAV_CARD] = 'Get Pre-Approved',
    _a[types.ADVERTISED_PRICE] = 'Advertised Price',
    _a[types.ADDITIONAL_DISCOUNTS_TITLE] = 'Additional Discounts',
    _a[types.DISCOUNT_REPLACE_WORD] = 'discounts',
    _a[types.TEST_VALUE] = 'Default Label',
    _a[types.DISCLAIMER] = '',
    _a[types.SPECIALS_LINK] = 'Search for Specials',
    _a[types.PROTECT_VEHICLE_DESCRIPTION] = 'These are great ways to extend the life of your vehicle and ensure your safety - ' +
        'you can change them at any point before your purchase is finalized.',
    _a[types.PROTECT_VEHICLE_SECONDARY_HEADER] = 'Choose plans that work best for your driving needs',
    _a[types.TEST_DRIVE_TITLE] = 'Take it for a spin first!',
    _a[types.TEST_DRIVE_DESCRIPTION] = 'Scheduling your test drive in advance will save you time. ' +
        'We will provide you with a complete vehicle demonstration and take time to answer all of your questions. ' +
        'If you have a vehicle to trade-in, we will be happy to provide an appraisal while you are ' +
        'taking your test drive to save even more time. Schedule your preferred time and we will confirm your appointment.',
    _a[types.TEST_DRIVE_SUCCESS_TITLE] = 'Test Drive Scheduled',
    _a[types.TEST_DRIVE_SUCCESS_DESCRIPTION] = 'If you have immediate questions or would like to cancel, please call us directly at the number below.',
    _a[types.CREDIT_APP_TITLE] = 'Apply for Credit',
    _a[types.CREDIT_APP_DESCRIPTION] = '',
    _a[types.CREDIT_APP_DESCRIPTION_CREDITOVERWRITEBLOCK_TOGGLE] = 'Once your Credit Application is submitted, Payment ' +
        'Terms, Vehicle Protection, and Trade-In will no longer be changeable.',
    _a[types.VEHICLE_PROTECTION_PRICE_TITLE] = 'Vehicle Protection Total',
    _a[types.CASH_DOWN_LABEL_DS] = 'Cash Down',
    _a[types.DUE_AT_SIGNING_LABEL_DS] = 'Due At Signing',
    _a[types.SUMMARY_SPECIALS_TITLE] = 'Specials',
    _a[types.DEALSTARTER_SIDEBAR_HEADER_TITLE] = 'Start My Purchase',
    _a[types.REBATES_REPLACEMENT_WORD] = 'rebates',
    _a[types.SAVINGS_REPLACEMENT_WORD] = 'savings',
    _a[types.MANUFACTURER_INCENTIVES_TITLE] = 'Manufacturer Incentives',
    _a[types.DealSummaryLabelType.MSRP] = 'MSRP',
    _a[types.DealSummaryLabelType.MSRP_SHORT] = 'MSRP',
    _a[types.DealSummaryLabelType.MSRP_INFO] = '',
    _a[types.DealSummaryLabelType.NEGATIVE_SIGN] = '-',
    _a[types.DealSummaryLabelType.MANUFACTURER_INCENTIVES_NAME] = 'Manufacturer\'s Incentives',
    _a);
